import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      {/* Top: 4-column grid */}
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Column 1: Logo + Description */}
          <div>
            <Link
              to="/"
              className="text-background-50 font-heading text-xl font-semibold tracking-tight hover:text-background-200 transition-colors cursor-pointer"
            >
              pandabuy.digital
            </Link>
            <p className="mt-4 text-sm text-background-300/80 leading-relaxed">
              Your gateway to the pandabuyspreadsheet ecosystem — structured product comparison across sneakers, streetwear, electronics, and accessories. Smarter shopping starts here.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: More Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Resources */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/blog/pandabuyspreadsheet-guide"
                  className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Beginner Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/blog/best-sneaker-spreadsheets-2026"
                  className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Sneaker Guides
                </Link>
              </li>
              <li>
                <Link
                  to="/blog/pandabuyspreadsheet-for-resellers"
                  className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Reseller Tips
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Main Platform
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Pandabuy Sheet
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom: Brand + Copyright */}
      <div className="border-t border-background-300/10">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-6">
              <span className="text-5xl md:text-7xl font-heading font-bold text-background-300/20 tracking-widest select-none">
                PANDABUY
              </span>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400/60">
              <p>&copy; {new Date().getFullYear()} pandabuy.digital. All rights reserved.</p>
              <p>
                This site is an independent SEO resource. External links open on{' '}
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-300/70 hover:text-background-200 transition-colors cursor-pointer"
                >
                  kaspreadsheet.com
                </a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}